/**
 * A date of birth, written the way it is said in a US laboratory.
 *
 * The API returns ISO (1994-02-23) because that is what a date column is.
 * Every screen that showed it raw was showing an operator a format they do
 * not use, next to a search box that only accepted that same format — so
 * typing a birthday the way anybody actually says it found nothing.
 *
 * Deliberately string-based, NOT `new Date(...)`. A bare 'YYYY-MM-DD' is
 * parsed by JavaScript as UTC midnight and then rendered in local time, so
 * west of Greenwich every date of birth comes out a day early. A patient born
 * on the 23rd is not born on the 22nd because the server is in another
 * timezone.
 */

const ISO = /^(\d{4})-(\d{2})-(\d{2})/;

/** 1994-02-23 -> 02-23-1994. Anything unrecognised is returned untouched. */
export function usDate(value, sep = '-') {
  if (!value) return '';
  const m = ISO.exec(String(value));
  if (!m) return String(value);
  return `${m[2]}${sep}${m[3]}${sep}${m[1]}`;
}

/** 1994-02-23 -> 02/23/1994 */
export const usSlash = (value) => usDate(value, '/');

export default usDate;
